import { useLang } from 'hooks/lang';

import { actions, loaders } from 'entities';

import { Skeleton, Column } from 'components/Blocks';

import { SingleInvoiceAssign } from './Single';
import { TeamProjects } from './TeamProjects';
import { TwoColumnWrapper } from '../components';

import { usePendingActions } from 'providers/PendingActions';

import { cascadeEval } from 'utils/conditions';
import { compareByName, listRemove, sortByProperty } from 'utils/array';

export function InvoiceAssign() {
  const { t } = useLang();
  const { decreaseCount } = usePendingActions();

  const {
    data: projects,
    loading: loadingProjects,
    overwrite,
  } = loaders.invoice.unassignedInvoiceControls.use({
    defaultValue: [],

    parser: (list) =>
      sortByProperty(list, ['readyToInvoice', 'project'], {
        readyToInvoice: (a, b) => Number(b) - Number(a),

        project: compareByName,
      }),

    realTimeSubscription: {
      type: 'INVOICE_CONTROL_ASSIGNMENT',

      onMessage: (assigned, projects) =>
        listRemove(projects, assigned.project.id, ({ project }) => project.id),
    },
  });

  const assignInvoice = actions.invoice.assignInvoiceControl.use({
    onSuccess: (_, { projectId }) => {
      overwrite((old) => listRemove(old, projectId, ({ project }) => project.id));

      decreaseCount('UNASSIGNED_INVOICE_CONTROLS');
    },
  });

  return (
    <TwoColumnWrapper>
      <Column>
        {cascadeEval([
          {
            is: loadingProjects,
            then: () => <Skeleton quantity={2} height={290} />,
          },
          {
            is: !projects.length,
            then: () => <p className="text-center">{t('no-unassigned-projects-found')}</p>,
          },
          {
            is: loadingProjects,
            then: () => (
              <>
                {projects.map((control) => (
                  <SingleInvoiceAssign
                    key={control.project.id}
                    assign={assignInvoice.execute}
                    control={control}
                  />
                ))}
              </>
            ),
          },
        ])}
      </Column>

      <TeamProjects />
    </TwoColumnWrapper>
  );
}
